import { r as registerInstance, h } from './index-d4808923.js';
import { c as classesToString } from './utils-17533423.js';

const gravityLinkCss = ".link{text-decoration:none}.link--style-underline{text-decoration:underline}.link--color-dark{color:#000F1E;text-decoration-color:#000F1E}.link--color-dark-subtle{color:rgba(0, 15, 30, 0.6);text-decoration-color:rgba(0, 15, 30, 0.6)}.link--color-dark-muted{color:rgba(0, 15, 30, 0.4);text-decoration-color:rgba(0, 15, 30, 0.4)}.link--color-light{color:#FFFFFF;text-decoration-color:#FFFFFF}.link--color-light-subtle{color:rgba(255, 255, 255, 0.6);text-decoration-color:rgba(255, 255, 255, 0.6)}.link--color-light-muted{color:rgba(255, 255, 255, 0.4);text-decoration-color:rgba(255, 255, 255, 0.4)}.link--color-positive{color:#159D48;text-decoration-color:#159D48}.link--color-negative{color:#DB0A40;text-decoration-color:#DB0A40}.link--color-informative{color:#FF9000;text-decoration-color:#FF9000}.link--color-primary{color:#1B6AEE;text-decoration-color:#1B6AEE}.link--color-primary-lighter{color:#3279F0;text-decoration-color:#3279F0}.link--color-primary-darker{color:#175ACA;text-decoration-color:#175ACA}";
const GravityLinkStyle0 = gravityLinkCss;

const GravityLink = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.href = '';
        this.linkTitle = '';
        this.size = undefined;
        this.target = undefined;
        this.underline = true;
    }
    render() {
        const classes = [`link`, `link--color-${this.color}`];
        const relValue = this.target === `_blank` ? `noopener noreferrer` : undefined;
        if (this.underline) {
            classes.push(`link--style-underline`);
        }
        return (h("a", { key: '62f01b4ad181442f0f08dd5ba98db69818d3288b', class: classesToString(classes), href: this.href, target: this.target, rel: relValue }, h("gravity-text", { key: '86828b182be345e83d7dbc300a22d726500325d1', color: this.color, size: this.size }, this.linkTitle, h("slot", { key: '89c6dfe54754a918b6fb923be394f9a5ddf5bdc4' }))));
    }
};
GravityLink.style = GravityLinkStyle0;

export { GravityLink as gravity_link };

//# sourceMappingURL=gravity-link.entry.js.map